import { render, staticRenderFns } from "./InvoiceParameterTableBody.vue?vue&type=template&id=5477abd8&"
import script from "./InvoiceParameterTableBody.vue?vue&type=script&lang=js&"
export * from "./InvoiceParameterTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports